import React from 'react';
import { keys } from 'ramda';
import { isPresent } from 'utils/helperMethods';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import useScreen from 'hooks/useScreen';
import { Typography } from '@material-ui/core';

import UserPresenter from 'presenters/UserPresenter';
import useApp from 'reducers/hooks/useApp';

import Switch from 'sharedComponents/Switch';
import Title from 'components/LoanOfficerSettings/components/Title';

import AutoFollowupsMessagesForm from './components/AutoFollowupsMessagesForm';

import useStyles from './useStyles';

const ORDER_MAPPER = {
  firstMessage: 1,
  secondMessage: 2,
  thirdMessage: 3,
};

const WAITING_TIME_MAPPER = {
  firstMessage: 24,
  secondMessage: 48,
  thirdMessage: 72,
};

const AutoFollowupsMessages = props => {
  const { onBack } = props;
  const classes = useStyles();
  const { isMobile } = useScreen();
  const { t } = useTranslation();

  const { updateLoanOfficer, isUpdating, currentUser } = useApp();
  const isEnabledAutoFollowupsMessages = Boolean(UserPresenter.enabledAutoFollowupsMessages(currentUser));

  const handleEnableAutoFollowups = ({ target: { checked } }) => {
    updateLoanOfficer({ enabledAutoFollowupsMessages: checked });
  };

  const buildAutoFollowupsAttributes = values => {
    return keys(values).map(field => {
      const message = values[field];
      const order = ORDER_MAPPER[field];
      const waitingTime = WAITING_TIME_MAPPER[field];
      const autoFollowupsMessage = UserPresenter.autoFollowupsMessage(currentUser, ORDER_MAPPER[field]);
      const isExists = isPresent(autoFollowupsMessage);

      return isExists ? { id: autoFollowupsMessage.id, message, order, waitingTime } : { message, order, waitingTime };
    });
  };

  const handleChangeMessages = values => {
    const attributes = buildAutoFollowupsAttributes(values);
    updateLoanOfficer({ autoFollowupsMessagesAttributes: attributes });
  };

  return (
    <div className={classes.container}>
      {isMobile && <Title text={t('components.LoanOfficerSettings.AutoFollowupsMessages.title')} onBack={onBack} />}
      <div className={classes.switchBox}>
        <Typography variant="body1">{t('components.LoanOfficerSettings.AutoFollowupsMessages.switchTitle')}</Typography>
        <Switch
          checked={isEnabledAutoFollowupsMessages}
          onChange={handleEnableAutoFollowups}
          disabled={isUpdating}
          showLabel
        />
      </div>
      <div className={classes.form}>
        {isEnabledAutoFollowupsMessages && (
          <AutoFollowupsMessagesForm currentUser={currentUser} onSubmit={handleChangeMessages} />
        )}
      </div>
    </div>
  );
};

AutoFollowupsMessages.propTypes = {
  onBack: PropTypes.func.isRequired,
};

export default AutoFollowupsMessages;



// WEBPACK FOOTER //
// ./src/components/LoanOfficerSettings/components/AutoFollowupsMessages/AutoFollowupsMessages.js